export default __webpack_public_path__ + "static/media/avocadoTtsIt_It60.9a76167f.mp3";